import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { TechnicianWorkReport } from "@/features/office/reports/technician-work";
import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

// Lenient URL schema (strict enums on URL params crash the page — see
// webapp-routing.md). Filter state follows the shared `filters-new` chip DSL:
// market and technician (a user id).
const searchSchema = z.object({
  filters: z
    .object({
      market: withOperators(commaListSchema),
      technician: withOperators(commaListSchema),
      ...notificationSearchFragment,
    })
    .optional(),
  ...filterSearchFragment,
  ...maskSearchFragment,
});

export const routeId = "/office/reports/technician-work";
export const Route = createFileRoute("/office/reports/technician-work")({
  validateSearch: searchSchema,
  component: TechnicianWorkReport,
});
